<template>
  <div>
    <el-card shadow="hover" style="margin-bottom: 10px" >
      <div class="header_right">
        <h3>基础信息</h3>
      </div>
      <div class="warp">
          <page-form :ref-obj.sync="formInfo.ref"
                     permission="goodsManageAdd"
                     :data="otherDetailList"
                     :fileList="formFieldList"
                     :labelWidth="formInfo.labelWidth"
                     :ruleList="formInfo.rules">
            <template v-slot:form-money>
              <el-input v-model.trim="otherDetailMoney" placeholder="请输入" maxlength="5" readonly>
                <template slot="append">元</template>
              </el-input>
            </template>
            <template v-slot:form-ycodCostTime>
              <el-input v-model.trim="otherDetailList.ycodCostTime" placeholder="请输入" maxlength="5" readonly>
              </el-input>
            </template>
            <template v-slot:form-supplier>
              <el-input v-model.trim="otherDetailList.supplier" placeholder="请输入" maxlength="5" readonly>
              </el-input>
            </template>
            <template v-slot:form-ycodDesc>
              <el-input type="textarea" v-model.trim="otherDetailList.ycodDesc" placeholder="请输入" maxlength="5" readonly>
              </el-input>
            </template>
          </page-form>
          <div class="settlement">
                  <div style="color:#8d8d8d">状态</div>
                  <span v-if="otherDetailList.settlementStatus === 0" class="settlementTxt">未结算</span>
                  <span v-else-if="otherDetailList.settlementStatus === 1" class="status-open settlementTxt"  style="color: #008000">已结算</span>
                  <span v-else-if="otherDetailList.settlementStatus === 3" class="status-open settlementTxt" style="color: #FF6700">结算中</span>
                  <span v-else class="status-close settlementTxt" style="color: #808080">已作废</span>
                </div>
      </div>
      <div class="text">补充凭证：</div>
      <div class="goodsImg" style="margin-left: 100px;">
        <upload-pic ref="upload"
                        :pictureList="urlPicArr"
                        :isDisabled="true"
                        :limit="3"></upload-pic>
      </div>
    </el-card>
  </div>
</template>

<script>
import pageForm from '@/components/Form/Index'
import pageTable from '@/components/Table/Index'
import costMenu from '../../store/costMenu/index.js'
import { OTHERDETATL } from '../../store/costMenu/types.js'
import uploadPic from '@/page/assignmentManage/components/uploadImage.vue'
export default {
  name: 'othercost',
  data () {
    return {
      formInfo: {
        ref: null,
        code: '',
        rules: {},
        labelWidth: '120px'
      },
      picUrl: this.$global.httpBaseURL
    }
  },
  components: {
    pageForm,
    pageTable,
    uploadPic
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.money = this.$route.params.money
        this.getList()
      }
    }
  },
  computed: {
    // 表单验证
    formFieldList () {
      return [
        {label: '编号：', prop: 'code', type: 'text', required: false},
        {label: '创建人：', prop: 'createName', type: 'text', required: false},
        {label: '生成时间：', prop: 'createTime', type: 'text', required: false},
        {label: '结算时间：', prop: 'settlementTime', type: 'text', required: false},
        {label: '供应商：', prop: 'supplier', type: 'slot', required: false},
        {label: '总金额：', prop: 'money', type: 'slot', append: '元'},
        {label: '计费时间：', prop: 'ycodCostTime', type: 'slot'},
        {label: '费用说明：', prop: 'ycodDesc', type: 'slot', disabled: true}
      ]
    },
    // 其他费用数据
    otherDetailList () {
      return costMenu.state.otherDetailList
    },
    imgURL () {
      return costMenu.state.imgURL
    },
    urlPicArr () {
      let url = []
      let urlpic = this.otherDetailList.ycodImg || ''
      if (urlpic === '') {
        url = []
      } else if (urlpic !== '' && urlpic.indexOf(',') === -1) {
        url = [{ url: this.picUrl + '/image/' + urlpic }]
      } else {
        url = urlpic.split(',')
        for (let i = 0; i < url.length; i++) {
          url[i] = { url: this.picUrl + '/image/' + url[i] }
        }
      }
      return url
    },
    otherDetailMoney () {
      let otherDetailMoney = parseFloat(this.otherDetailList.money).toFixed(2)
      return otherDetailMoney
    }
  },
  mounted () {
    // 获取其他费用详情
    this.code = this.$route.params.code
    this.type = this.$route.params.type
    this.getList()
  },
  methods: {
    // 获取其他费用详情
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(OTHERDETATL, params)
    }
  }
}
</script>

<style scoped>
.warp,.goodsImg {
    display: flex;
    padding: 20px 50px 0
}
.warp >>> .el-form:last-child {
    margin-left: 100px;
}
.warp >>> .el-textarea__inner {
    width: 600px;
    resize: none;
    height: 150px;
}
.warp >>> .el-input{
    width: 200px !important
}
.disUoloadSty .el-upload--picture-card{
  display:none;   /* 上传按钮隐藏 */
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .text{
  margin-left: 150px;
}
.header_right {
  width: 60%;
  display: flex;
  justify-content: space-between;
}
.settlement {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 600px;
}
.settlementTxt {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/page/costMenu/OtherCostDetail.vue